import { createContext, useContext } from 'react';
import api from '../lib/api';
import useAsync from '../hooks/useAsync';

const SettingsContext = createContext({ showPricing: true, loading: true });

export function SettingsProvider({ children }) {
  const { data, loading } = useAsync(
    () => api.get('/settings').then((r) => r.data),
    []
  );
  // Default to showing prices unless explicitly turned off.
  const value = { showPricing: data ? data.showPricing !== false : true, loading };
  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
